<template>
      <v-card>
        <v-card-title>
        <v-list-item class="grow">
          Buat Berita
          <v-row align="center" justify="end">
            <v-icon class="mr-1" @click="setdialog(false)">
              close
            </v-icon>
          </v-row>
        </v-list-item>
        </v-card-title>
        <v-divider/>
          <div class="ma-2 mt-2 pt-2">
            <div class=""> <v-textarea rounded filled label="Bagikan informasi"  rows="4" v-model="newpost.msg"/></div>
          </div>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn elevation="0" class="primary">Posting</v-btn>
        </v-card-actions>
      </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'PostEditor',
  data: () => ({
    newpost: {
      msg: '',
      image: ''
    }
  }),
  computed: {
    ...mapState('FeedStore', ['dialog'])
  },
  methods: {
    ...mapActions('FeedStore', ['setdialog'])
  }
}
</script>

<style scoped>

</style>
